/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBookImportResult } from '../../models/address-book-import-result';
import { BaseResponse } from '../../models/base-response';

export interface AddressBookControllerImportContacts$Params {
      body: {
'address_book_file'?: any;
}
}

export function addressBookControllerImportContacts(http: HttpClient, rootUrl: string, params: AddressBookControllerImportContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookImportResult;
}>> {
  const rb = new RequestBuilder(rootUrl, addressBookControllerImportContacts.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AddressBookImportResult;
      }>;
    })
  );
}

addressBookControllerImportContacts.PATH = '/address-book/import';
